module.exports = __webpack_public_path__ + "img/chargingpoint-definitive.0701d0a3.png";